import React, { useContext, useState } from 'react'
import { ContextoGlobal, ContextoGlobalInterface } from '../../../GlobalStates/ContextoGlobal';

import DataTable, { DataTableCabecalhoColSpanInterface, DataTableCabecalhoInterface } from '../../../DevComponents/DataTable';
import { useNavigate } from 'react-router-dom';

import BackEndAPI from '../../../Services/BackEndAPI';
import { MensagemTipo } from '../../../GlobalStates/MensagemState';
import { RespostaPadraoInterface } from '../../../ImportBackend/Interfaces/PadraoInterfaces';
import { DateTime } from 'luxon';
import { DTFORMAT } from '../../../Utils/ClsFormatacao';
import ClsValidacao from '../../../Utils/ClsValidacao';

import { Box, Button, Container, Grid, IconButton, Paper, Tab, Tabs, Typography } from '@mui/material'

import CloseIcon from '@mui/icons-material/Close'
import CheckIcon from '@mui/icons-material/Check'
import InputText from '../../../DevComponents/InputText'
import Condicional from '../../../Layout/Condicional'
import ModalComponent from '../../../DevComponents/ModalComponent';

import TextArea from '../../../DevComponents/TextArea';
import { FatorRHColaboradorInterface, FatorRHLogInterface } from '../../../ImportBackend/Interfaces/FatorRHInterfaces';
import ExibirJSONDev from '../../../DevComponents/ExibirJSONDev';
import { EMDESENVOLVIMENTO } from '../../../ImportBackend/Config/emDesenvolvimento';

export default function FatorRHEnvio() {

  const contexto = useContext(ContextoGlobal) as ContextoGlobalInterface
  const { mensagemState, setMensagemState, loginState } = contexto

  const navigate = useNavigate()

  const ResetDados = {
    idCliente: loginState.idClienteAtual,
    data: DateTime.now().toFormat(DTFORMAT.BANCO),
    exibirApenasErros: true,
    dataInicio: DateTime.now().toFormat(DTFORMAT.BANCO),
    dataTermino: DateTime.now().toFormat(DTFORMAT.BANCO)
  }

  const [dados, setDados] = useState<typeof ResetDados>({ ...ResetDados })
  const [erros, setErros] = useState({})

  const [rsLog, setRsLog] = useState<Array<FatorRHLogInterface>>([])
  const [rsLogDetalhe, setRsLogDetalhe] = useState<Array<FatorRHColaboradorInterface>>([])

  const clsApi: BackEndAPI = new BackEndAPI()

  const validarDados = (): boolean => {

    let retorno: boolean = true
    let erros: { [key: string]: string } = {}

    let clsValidacao = new ClsValidacao()

    retorno = clsValidacao.eData('data', dados, erros, retorno, true)
    retorno = clsValidacao.naoVazio('idCliente', dados, erros, retorno)

    setErros(erros)

    return retorno

  }

  const onEnviarFatorRH = () => {

    if (validarDados()) {

      const mutation = `
        enviarFatorRH (data: "${dados.data}", idCliente: ${dados.idCliente}) {
          ok
          mensagem
        }
      `

      clsApi.mutation<RespostaPadraoInterface>(mutation, 'enviarFatorRH', 'Enviando Fator RH...', contexto).then(rs => {

        if (rs.ok) {

          setMensagemState({
            ...mensagemState,
            titulo: 'FatorRH enviado com sucesso!',
            exibir: true,
            mensagem: 'Verifique as críticas no LOG!.',
            tipo: MensagemTipo.Info,
            exibirBotao: true
          })

        } else {

          setMensagemState({
            ...mensagemState,
            titulo: 'FatorRH não enviado!',
            exibir: true,
            mensagem: rs.mensagem,
            tipo: MensagemTipo.Error,
            exibirBotao: true
          })

        }

      }).catch(() => {

        setMensagemState({
          ...mensagemState,
          titulo: 'Erro! Consulte Suporte!',
          exibir: true,
          mensagem: 'Erro ao enviar FatorRH!',
          tipo: MensagemTipo.Error,
          exibirBotao: true
        })

      })

    }

  }

  const pesquisarDetalhe = () => {
    const query = `
        getLogsFatorRHDetalhe (dataInicio: "${dados.dataInicio}", dataTermino: "${dados.dataTermino}", idCliente: ${dados.idCliente}, exibirApenasErros: ${dados.exibirApenasErros}) {
          idFatorRHColaborador
          identificador
          transmitidoAdmissao
          erroTransmissaoAdmissao
          logAdmissao
          dadosAdmissao
          dataTransmissaoAdmissao
          transmitidoAfastamento
          erroTransmissaoAfastamento
          logAfastamento
          dadosAfastamento
          dataTransmissaoAfastamento
          transmitidoDesligamento
          erroTransmissaoDesligamento
          logDesligamento
          dadosDesligamento
          dataTransmissaoDesligamento
        }
      `

    clsApi.query<Array<FatorRHColaboradorInterface>>(query, 'getLogsFatorRHDetalhe', 'Exibir Logs FatorRH...', contexto).then(rsLogs => {

      setRsLogDetalhe(rsLogs)

    }).catch(() => {

      setRsLogDetalhe([])

      setMensagemState({
        ...mensagemState,
        titulo: 'Erro! Consulte Suporte!',
        exibir: true,
        mensagem: 'Erro ao exibir Logs FatorRH!',
        tipo: MensagemTipo.Error,
        exibirBotao: true
      })

    })
  }

  const pesquisarLogs = () => {
    const query = `
        getLogsFatorRH (dataInicio: "${dados.dataInicio}", dataTermino: "${dados.dataTermino}", idCliente: ${dados.idCliente}, exibirApenasErros: ${dados.exibirApenasErros}) {
          idUsuario
          tipoOperacao
          dataReferencia
          sucesso
          mensagem
          createdAt
        }
      `

    clsApi.query<Array<FatorRHLogInterface>>(query, 'getLogsFatorRH', 'Exibir Logs FatorRH...', contexto).then(rsLogs => {

      setRsLog(rsLogs)

    }).catch(() => {

      setRsLog([])

      setMensagemState({
        ...mensagemState,
        titulo: 'Erro! Consulte Suporte!',
        exibir: true,
        mensagem: 'Erro ao exibir Logs FatorRH!',
        tipo: MensagemTipo.Error,
        exibirBotao: true
      })

    })
  }

  const onExibirLogs = () => {

    if (validarDados()) {

      pesquisarDetalhe()
      pesquisarLogs()

    }

  }

  const [rsTab, setRsTab] = useState(0)

  const changeRsTab = (_event: React.SyntheticEvent, newValue: number) => {
    setRsTab(newValue)
  }

  const Cabecalho: Array<DataTableCabecalhoInterface> = [
    {
      cabecalho: 'Data Referência',
      campo: 'dataReferencia',
      alinhamento: 'left',
      format: (v) => DateTime.fromISO(v).toFormat(DTFORMAT.USUARIO)
    },
    {
      cabecalho: 'Data/Hora Transmissão',
      campo: 'createdAt',
      alinhamento: 'left',
      format: (v) => DateTime.fromISO(v).toFormat(DTFORMAT.USUARIO_DATETIME)
    },
    {
      cabecalho: 'Usuário',
      campo: 'idUsuario',
      alinhamento: 'right'
    },
    {
      cabecalho: 'Operação',
      campo: 'tipoOperacao',
      alinhamento: 'left'
    },
    {
      cabecalho: 'Sucesso',
      campo: 'sucesso',
      alinhamento: 'left',
      format: (v) => v ? 'Sim' : 'Não'
    },
    {
      cabecalho: 'Log',
      campo: 'mensagem',
      alinhamento: 'left'
    }
  ]

  const CabecalhoDetalheColSpan: Array<DataTableCabecalhoColSpanInterface> = [
    {
      alinhamento: 'center',
      cabecalho: '',
      largura: 1
    },
    {
      alinhamento: 'center',
      cabecalho: 'Admissão',
      largura: 4
    },
    {
      alinhamento: 'center',
      cabecalho: 'Afastamento',
      largura: 4
    },
    {
      alinhamento: 'center',
      cabecalho: 'Desligamento',
      largura: 4
    },
    {
      alinhamento: 'center',
      cabecalho: '',
      largura: 1
    }
  ]

  const CabecalhoDetalhe: Array<DataTableCabecalhoInterface> = [
    {
      cabecalho: 'Identificador',
      campo: 'identificador',
      alinhamento: 'right'
    },
    {
      cabecalho: 'Data',
      campo: 'dataTransmissaoAdmissao',
      alinhamento: 'left',
      format: (v) => v ? DateTime.fromMillis(parseInt(v)).toFormat(DTFORMAT.USUARIO_DATETIME) : '---'
    },
    {
      cabecalho: 'Transmitido',
      campo: 'transmitidoAdmissao',
      alinhamento: 'left',
      format: (v) => v ? 'Sim' : 'Não'
    },
    {
      cabecalho: 'Erro',
      campo: 'erroTransmissaoAdmissao',
      alinhamento: 'left',
      format: (v) => v ? 'Sim' : 'Não'
    },
    {
      cabecalho: 'Log',
      campo: 'logAdmissao',
      alinhamento: 'left'
    },
    /*    {
          cabecalho: 'Dados',
          campo: 'dadosAdmissao',
          alinhamento: 'left'
        },
        */
    {
      cabecalho: 'Data',
      campo: 'dataTransmissaoAfastamento',
      alinhamento: 'left',
      format: (v) => v ? DateTime.fromMillis(parseInt(v)).toFormat(DTFORMAT.USUARIO_DATETIME) : '---'
    },
    {
      cabecalho: 'Transmitido',
      campo: 'transmitidoAfastamento',
      alinhamento: 'left',
      format: (v) => v ? 'Sim' : 'Não'
    },
    {
      cabecalho: 'Erro',
      campo: 'erroTransmissaoAfastamento',
      alinhamento: 'left',
      format: (v) => v ? 'Sim' : 'Não'
    },
    {
      cabecalho: 'Log',
      campo: 'logAfastamento',
      alinhamento: 'left'
    },
    /*    {
          cabecalho: 'Dados',
          campo: 'dadosAfastamento',
          alinhamento: 'left'
        },
        */
    {
      cabecalho: 'Data',
      campo: 'dataTransmissaoDesligamento',
      alinhamento: 'left',
      format: (v) => v ? DateTime.fromMillis(parseInt(v)).toFormat(DTFORMAT.USUARIO_DATETIME) : '---'
    },
    {
      cabecalho: 'Transmitido',
      campo: 'transmitidoDesligamento',
      alinhamento: 'left',
      format: (v) => v ? 'Sim' : 'Não'
    },
    {
      cabecalho: 'Erro',
      campo: 'erroTransmissaoDesligamento',
      alinhamento: 'left',
      format: (v) => v ? 'Sim' : 'Não'
    },
    {
      cabecalho: 'Log',
      campo: 'logDesligamento',
      alinhamento: 'left'
    },
    /*    {
          cabecalho: 'Dados',
          campo: 'dadosDesligamento',
          alinhamento: 'left'
        },
        */
  ]

  const [currentPageOptions, setCurrentPageOptions] = useState<{ page: number; rowsPerPage: number }>({ page: 0, rowsPerPage: 10 })

  const onChangeCurrentPageOptions = (options: { page: number; rowsPerPage: number }) => {
    setCurrentPageOptions(options)
  }

  const onRetransmitirFatorRH = (rsFatorRHEnvio: FatorRHColaboradorInterface) => {

    const mutation = `
        100 (data: "${rsFatorRHEnvio.dataTransmissaoAdmissao}", idCliente: ${dados.idCliente}, identificador: "${rsFatorRHEnvio.identificador}") {
          ok
          mensagem
        }
      `

    clsApi.mutation<RespostaPadraoInterface>(mutation, 'enviarFatorRH', 'Enviando Fator RH...', contexto).then(rs => {

      if (rs.ok) {

        setMensagemState({
          ...mensagemState,
          titulo: 'Fator RH enviado com sucesso!',
          exibir: true,
          mensagem: 'Verifique as críticas no LOG!.',
          tipo: MensagemTipo.Info,
          exibirBotao: true
        })

      } else {

        setMensagemState({
          ...mensagemState,
          titulo: 'Fator RH não enviado!',
          exibir: true,
          mensagem: rs.mensagem,
          tipo: MensagemTipo.Error,
          exibirBotao: true
        })

      }

    }).catch(() => {

      setMensagemState({
        ...mensagemState,
        titulo: 'Erro! Consulte Suporte!',
        exibir: true,
        mensagem: 'Erro ao enviar Fator RH!',
        tipo: MensagemTipo.Error,
        exibirBotao: true
      })

    })
  }

  const onExibirLOG = (rsFatorRHEnvio: FatorRHColaboradorInterface) => {

    const texto: string = ''
      .concat(
        'Dados de Admissão:',
        '\n',
        '==================',
        '\n* ',
        rsFatorRHEnvio.logAdmissao ? rsFatorRHEnvio.logAdmissao.replaceAll('| ', '\n* ') : '',
        '\n\n',
        JSON.stringify(JSON.parse(rsFatorRHEnvio.dadosAdmissao ? rsFatorRHEnvio.dadosAdmissao : '{}'), null, 4),
        '\n'.repeat(3),
        'Dados de Afastamento:',
        '\n',
        '==================',
        '\n* ',
        rsFatorRHEnvio.logAfastamento ? rsFatorRHEnvio.logAfastamento.replaceAll('| ', '\n* ') : '',
        '\n\n',
        JSON.stringify(JSON.parse(rsFatorRHEnvio.dadosAfastamento ? rsFatorRHEnvio.dadosAfastamento : '{}'), null, 4),
        '\n'.repeat(3),
        'Dados de Desligamento:',
        '\n',
        '==================',
        '\n* ',
        rsFatorRHEnvio.logDesligamento ? rsFatorRHEnvio.logDesligamento.replaceAll('| ', '\n* ') : '',
        '\n\n',
        JSON.stringify(JSON.parse(rsFatorRHEnvio.dadosDesligamento ? rsFatorRHEnvio.dadosDesligamento : '{}'), null, 4)
      )

    setExibirXML(texto)

  }

  const [exibirXML, setExibirXML] = useState('')

  return (

    <>

      <Container maxWidth="lg" sx={{ mt: 5 }}>

        <Paper variant="outlined" sx={{ padding: 2 }}>

          <Grid container sx={{ display: 'flex', alignItems: 'stretch' }}>

            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>

              <Typography component="h5" variant="h5" align="left">
                Enviar Fator RH
                <Typography variant="body2" gutterBottom>
                  Envio e Visualização de LOGs
                </Typography>
              </Typography>

              <IconButton onClick={() => navigate('/')}>
                <CloseIcon />
              </IconButton>

            </Grid>

            <Grid item xs={12}>

              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={rsTab} onChange={changeRsTab} aria-label="FatorRH envio tabs">
                  <Tab label="Envio" />
                  <Tab label="Logs" />
                </Tabs>
              </Box>

            </Grid>

            <Condicional condicao={rsTab === 0}>

              <Grid item xs={12} md={6} sx={{ mt: 3 }}>
                <InputText
                  dados={dados}
                  field='data'
                  label='Data de Referência'
                  setState={setDados}
                  erros={erros}
                  tipo='date'
                />
              </Grid>

              <Grid item xs={12} md={6} sx={{ mt: 6, pl: { md: 1 }, textAlign: 'right' }} >
                <Button variant='contained' startIcon={<CheckIcon />} sx={{ my: 1, py: 1, mr: 2 }} onClick={() => onEnviarFatorRH()}>Enviar</Button>
              </Grid>

            </Condicional>

            <Condicional condicao={rsTab === 1}>

              <Grid item xs={12} md={3} sx={{ mt: 3 }}>
                <InputText
                  dados={dados}
                  field='dataInicio'
                  label='Data de Início'
                  setState={setDados}
                  erros={erros}
                  tipo='date'
                />
              </Grid>

              <Grid item xs={12} md={3} sx={{ mt: 3, pl: { md: 1 } }}>
                <InputText
                  dados={dados}
                  field='dataTermino'
                  label='Data de Término'
                  setState={setDados}
                  erros={erros}
                  tipo='date'
                />
              </Grid>

              <Grid item xs={12} md={3} sx={{ mt: 7, pl: { md: 1 }, textAlign: 'center' }} >

                <InputText
                  dados={dados}
                  field='exibirApenasErros'
                  label='Exibir Apenas Erros'
                  setState={setDados}
                  erros={erros}
                  tipo='checkbox'
                />

              </Grid>

              <Grid item xs={12} md={3} sx={{ mt: 6, pl: { md: 1 }, textAlign: 'right' }} >
                <Button variant='contained' startIcon={<CheckIcon />} sx={{ my: 1, py: 1, mr: 2 }} onClick={() => onExibirLogs()}>Exibir Logs</Button>
              </Grid>

              <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>

                <Typography component="h5" variant="h5" align="left">
                  Logs Fator RH
                  <Typography variant="body2" gutterBottom>
                    Envios
                  </Typography>
                </Typography>

                <IconButton onClick={() => navigate('/')}>
                  <CloseIcon />
                </IconButton>

              </Grid>

              <Grid item xs={12}>

                <DataTable<FatorRHColaboradorInterface>
                  dados={rsLog}
                  onChangeCurrentPageOptions={(rs) => onChangeCurrentPageOptions(rs)}
                  currentPageOptions={currentPageOptions}
                  cabecalho={Cabecalho} acoes={
                    [
                      // { icone: 'visibility', toolTip: 'XML', onAcionador: (rs) => onExibirXML(rs) },
                      // { icone: 'send', toolTip: 'Retransmitir', onAcionador: (rs) => onRetransmitirFatorRH(rs) }
                    ]
                  } />

              </Grid>

              <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>

                <Typography variant="body2" gutterBottom>
                  Detalhes do Envio
                </Typography>

                <IconButton onClick={() => navigate('/')}>
                  <CloseIcon />
                </IconButton>

              </Grid>

              <Grid item xs={12}>

                <DataTable<FatorRHColaboradorInterface>
                  dados={rsLogDetalhe}
                  onChangeCurrentPageOptions={(rs) => onChangeCurrentPageOptions(rs)}
                  currentPageOptions={currentPageOptions}
                  cabecalhoColSpan={CabecalhoDetalheColSpan}
                  cabecalho={CabecalhoDetalhe} acoes={
                    [
                      { icone: 'visibility', toolTip: 'LOG', onAcionador: (rs) => onExibirLOG(rs) },
                      { icone: 'send', toolTip: 'Retransmitir', onAcionador: (rs) => onRetransmitirFatorRH(rs) }
                    ]

                  } />

              </Grid>

            </Condicional>

            <ModalComponent
              exibir={exibirXML.length > 0}
              setExibir={() => setExibirXML('')}
            >
              <Box sx={{ m: 2, p: 2, borderBottom: 1, borderColor: 'divider' }}>
                <TextArea
                  dados={{ dados: exibirXML }}
                  field='dados'
                  label='Dados Fator RH'
                  disabled={true}
                  height='400px'
                />
              </Box>
            </ModalComponent>

          </Grid>

          <ExibirJSONDev exibir={EMDESENVOLVIMENTO} oque={['Dados', dados]} />
        </Paper>
      </Container>

    </>

  )
}